import React, { useEffect, useState } from "react";
import { Modal, Skeleton } from "antd";
import classes from "./preview-modal.module.scss";
import AutoViewer from "./atomics/auto-viewer/auto-viewer";
import classNames from "classnames";

const PreviewModal = ({ uri, isOpen, handleClose, fileName }) => {
  const [displayChildren, setDisplayChildren] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        setDisplayChildren(true);
      }, 500);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        open={isOpen}
        width="80%"
        title="Preview"
        onCancel={handleClose}
        style={{ top: 30 }}
        bodyStyle={{ height: "80vh" }}
        className={classes.Modal}
        footer={
          <div className={classes.FooterWrap}>
            <span style={{ whiteSpace: "nowrap" }}>Download PDF:</span>
            &nbsp;&nbsp;
            <a className={classes.Link} target="_blank" href={uri}>
              {fileName}
            </a>
            <button
              onClick={handleClose}
              className={classNames(classes.Button, "btn btn-primary")}
            >
              Close
            </button>
          </div>
        }
      >
        {displayChildren ? (
          <AutoViewer uri={uri} />
        ) : (
          <Skeleton.Image active className={classes.SkeletonImage}>
            <div>Skeleton</div>
          </Skeleton.Image>
        )}
      </Modal>
    </>
  );
};

export default PreviewModal;
